<app-header></app-header>
<ion-content data-cy="browse-content">
  <ng-container *ngIf="isGuestUser === false">
    <ng-container *ngTemplateOutlet="browseProducts"></ng-container>
  </ng-container>
  <ng-container *ngIf="isGuestUser === true">
    <ng-container *ngIf="splitDynamicGuestAbTestEnabled === true">
      <ng-container *ngTemplateOutlet="guestBrowseProducts"></ng-container>
    </ng-container>
    <ng-container *ngIf="splitDynamicGuestAbTestEnabled === false">
      <ng-container *ngTemplateOutlet="browseProducts"></ng-container>
    </ng-container>
  </ng-container>

  <ng-template #browseProducts>
    <app-browse-products
      [browseHierarchyViewModel]="browseHierarchyViewModel"
      [isGuestUser]="isGuestUser"
      [searchPath]="searchPath"
      [browseScoopParams]="browseScoopParams"
      [scoopImageUrl]="scoopImageUrl"
      [directImageUrl]="directImageUrl"
      [directId]="directId"
      [isDirectEligible]="isDirectEligible"
      [directQueryParams]="directQueryParams"
      [neweandsParams]="neweandsParams"
      [recentlyViewedProducts$]="recentlyViewedProducts$"
      [platformService]="platformService"
      (quantityUpdateEmitter)="onTopSellerQuantityUpdate($event)"
      (recentlyViewedQuantityUpdateEmitter)="onRecentlyViewedQuantityUpdate($event)"
      (productClickEmitter)="emitProductCardClick($event)"
      [newTopSellers]="newTopSellers"
      [lnkSrc]="lnkSrc"
    ></app-browse-products>
  </ng-template>

  <ng-template #guestBrowseProducts>
    <app-guest-browse-products
      [browseHierarchyViewModel]="browseHierarchyViewModel"
      [isGuestUser]="isGuestUser"
      [searchPath]="searchPath"
      [browseScoopParams]="browseScoopParams"
      [scoopImageUrl]="scoopImageUrl"
      [directImageUrl]="directImageUrl"
      [directId]="directId"
      [isDirectEligible]="isDirectEligible"
      [directQueryParams]="directQueryParams"
      [neweandsParams]="neweandsParams"
      [recentlyViewedProducts$]="recentlyViewedProducts$"
      [platformService]="platformService"
      (quantityUpdateEmitter)="onTopSellerQuantityUpdate($event)"
      (recentlyViewedQuantityUpdateEmitter)="onRecentlyViewedQuantityUpdate($event)"
      (productClickEmitter)="emitProductCardClick($event)"
      [newTopSellers]="newTopSellers"
      [lnkSrc]="lnkSrc"
    ></app-guest-browse-products>
  </ng-template>

  <app-footer
    *ngIf="platformService.platformType === platformService?.platformEnum?.desktop"
  ></app-footer>
</ion-content>
